<script lang="ts" setup>
import { ModalHeadProps } from "~/components/Filters/Utils/ModalHead.props"

withDefaults(defineProps<ModalHeadProps>(), {
  type: "primary",
  action: "none"
})

const emit =
  defineEmits<{
    (e: "onClose"): void
    (e: "onSelectAll"): void
    (e: "onDeleteAll"): void
  }>()
</script>

<template>
  <header
    class="modal-head h-12 bg-grey-main px-4"
    :class="{ 'rounded-t-lg': type === 'secondary' }"
  >
    <div
      v-if="type === 'primary'"
      class="flex h-full items-center justify-between gap-x-2"
    >
      <button
        v-if="!!title"
        type="button"
        class="dolphin-bold flex items-center"
        @click="emit('onClose')"
      >
        <UtilsIcon name="ArrowIosLeft.svg" />
        {{ title }}
      </button>
      <UtilsButton
        v-if="action !== 'none'"
        theme="ghost-green"
        class="[&>div]:py-2"
        :text="$t(`filters.utils.modalHead.${action}`)"
        order="last"
        @click="
          action === 'selectAll' ? emit('onSelectAll') : emit('onDeleteAll')
        "
      >
        <template v-if="action === 'selectAll'" #icon>
          <UtilsIcon name="Checkmark.svg" class="h-5 w-5" />
        </template>
      </UtilsButton>
    </div>
    <div v-else class="flex h-full items-center gap-x-4">
      <h4 class="dolphin-bold flex-1 text-center">{{ title }}</h4>
      <UtilsButton
        class="[&>div]:p-0"
        theme="ghost-black"
        @click="emit('onClose')"
      >
        <template #icon>
          <UtilsIcon name="Close.svg" class="h-6 w-6" />
        </template>
      </UtilsButton>
    </div>
  </header>
</template>
